<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>费用</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.fytype" placeholder="请选择" style="width: 100%">
              <el-option label="请选择费用类型" value="0"></el-option>
              <el-option label="研发费" value="1"></el-option>
              <el-option label="生产费" value="2"></el-option>
              <el-option label="采购费" value="3"></el-option>
              <el-option label="其他" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="10%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="10%"></el-table-column>
          <el-table-column prop="Fytype" label="费用类型" min-width="5%"></el-table-column>
          <el-table-column prop="Fyliyou" label="付款原因" min-width="18%"></el-table-column>
          <el-table-column prop="Fymoney" label="费用金额" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="发生日期" min-width="8%"></el-table-column>
          <el-table-column prop="Fybeizhu" label="备注" min-width="20%"></el-table-column>
          <el-table-column label="费用凭证" min-width="6%">
            <template v-slot="scope">
              <el-button v-for="Fypzurl in scope.row.Fypzurls" type="text" @click="clickfile(Fypzurl)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="4%"></el-table-column>
          <el-table-column prop="Fypaystatusname" label="支付状态" min-width="5%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Fypaystatus == 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="SubRule_ShenPiFeiYong_CaiWu && scope.row.Fypaystatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickzhifu(scope.row,0)">未支付</el-button>
              <el-button v-if="SubRule_ShenPiFeiYong_CaiWu && scope.row.Fypaystatus == 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickzhifu(scope.row,1)">已支付</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加费用" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <div class="warntitle">先将纸质付款申请单全部审核完毕，然后再拍照上传睿云。</div>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用类型(必选)</span>
          </label>
          <el-select v-model="addForm.fytype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="研发费" value="1"></el-option>
            <el-option label="生产费" value="2"></el-option>
            <el-option label="采购费" value="3"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">申请事由(必填)</span>
          </label>
          <el-input v-model="addForm.fyliyou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用金额(必填)</span>
          </label>
          <el-input v-model="addForm.fymoney"></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.fybeizhu"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">费用凭证(必填)</span>
          </label>
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    TencentyunCosUploadMultiImgOrPdf
  },
  name: 'MyShenPiFeiYong',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        fytype: '0',
        fyliyou: '',
        fymoney: '',
        fybeizhu: '',
        fypzurl: ''
      },
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        fytype: '0'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiFeiYongSHUrl: '',
      fyid: 0,
      SubRule_ShenPiFeiYong_BuMen: false,
      SubRule_ShenPiFeiYong_DanWei: false,
      SubRule_ShenPiFeiYong_DanWeiZong: false,
      SubRule_ShenPiFeiYong_CaiWu: false
    }
  },
  mounted () {
    this.apiGetShenPiFeiYongNum()
    this.apiGetShenPiFeiYongList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiFeiYong_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiFeiYong_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiFeiYong_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiFeiYong_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiFeiYong_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiFeiYong_DanWeiZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiFeiYong_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiFeiYong_CaiWu = true
      }
    })
  },
  methods: {
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.fypzurl = url
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickadd () {
      this.apiAddShenPiFeiYong()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiFeiYongSHUrl = Vue.prototype.global.Url_ShenPiFeiYongSH1
      this.fyid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiFeiYongSHUrl = Vue.prototype.global.Url_ShenPiFeiYongSH2
      this.fyid = row.Id
    },
    ShenHe3 (row) {
      this.dialogVisible = true
      this.apiShenPiFeiYongSHUrl = Vue.prototype.global.Url_ShenPiFeiYongSH3
      this.fyid = row.Id
    },
    ShenHe4 (row) {
      this.dialogVisible = true
      this.apiShenPiFeiYongSHUrl = Vue.prototype.global.Url_ShenPiFeiYongSH4
      this.fyid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiFeiYongSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiFeiYongSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiFeiYong(row.Id)
      })
    },
    clickzhifu (row, fypaystatus) {
      this.apiChangeFeiYongPayStatus(row.Id, fypaystatus)
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiFeiYongNum()
      this.apiGetShenPiFeiYongList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiFeiYongList()
    },
    apiGetShenPiFeiYongNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        fytype: that.keywords.fytype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiFeiYongNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiFeiYongList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        fytype: that.keywords.fytype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiFeiYongList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Fypzurls = that.dataList[i].Fypzurl.split('@@@')
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiFeiYong: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fytype: that.addForm.fytype,
        fyliyou: that.addForm.fyliyou,
        fymoney: that.addForm.fymoney,
        fybeizhu: that.addForm.fybeizhu,
        fypzurl: that.addForm.fypzurl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiFeiYong, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiFeiYongNum()
            that.apiGetShenPiFeiYongList()

            // 清空添加
            that.addForm.fytype = '0'
            that.addForm.fyliyou = ''
            that.addForm.fymoney = ''
            that.addForm.fybeizhu = ''
            that.addForm.fypzurl = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiFeiYong: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fyid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiFeiYong, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiFeiYongNum()
            that.apiGetShenPiFeiYongList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiFeiYongSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fyid: that.fyid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiFeiYongSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiFeiYongNum()
            that.apiGetShenPiFeiYongList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiChangeFeiYongPayStatus: function (fyid, fypaystatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fyid: fyid,
        fypaystatus: fypaystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ChangeFeiYongPayStatus, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetShenPiFeiYongNum()
            that.apiGetShenPiFeiYongList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}
</style>
